import { render, staticRenderFns } from "./blog17.vue?vue&type=template&id=d9765f22"
import script from "./blog17.vue?vue&type=script&lang=js"
export * from "./blog17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports